export default __webpack_public_path__ + "static/media/treat-yourself-1920w.e52a98e1.png";